<!-- 群控管理 -->
<template>
<div class="container containerBox">
    <div class="container-title" style="margin-top:0;">控制方式</div>
    <div style="margin-left:150px;">
        <el-radio-group v-model="controlType" @change="handleChange">
            <el-radio :label="1">所有风盘</el-radio>
            <el-radio :label="2">所有风柜</el-radio>
            <el-radio :label="3">按组别控制</el-radio>
            <el-radio :label="4">按集控器控制</el-radio>
            <el-radio :label="5">按楼宇结构控制</el-radio>
        </el-radio-group>
    </div>
    <div class="container-title">控制参数</div>
    <div style="margin-left:90px;" class="group-form">
        <el-form :model="form" status-icon :rules="rules" ref="ruleForm2" label-width="100px" class="demo-ruleForm">
            <el-row :gutter="20">
                <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                    <el-form-item label="状态" prop="status">
                        <el-select v-model="form.status" clearable placeholder="请选择">
                            <el-option
                                v-for="(v, i) in configData.status"
                                :key="i"
                                :label="v.label"
                                :value="v.value"
                                :disabled="v.disable">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="模式" prop="module">
                        <el-select v-model="form.module" clearable placeholder="请选择">
                            <el-option
                                v-for="(v, i) in configData.pattern"
                                :key="i"
                                :label="v.label"
                                :value="v.value"
                                :disabled="v.disable">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <template v-if="controlType === 2">
                        <el-form-item label="制热温度" prop="heatingtemperture">
                            <el-input v-model="form.heatingtemperture" 
                                @blur="handleChangeInput('heatingtemperture')" 
                                clear 
                                placeholder="请输入制热温度"></el-input>&nbsp;&nbsp;°C
                        </el-form-item>
                    </template>
                    <template v-if="controlType === 1">
                        <el-form-item label="设温" prop="setTemperature">
                            <el-input v-model="form.setTemperature"
                                @blur="handleChangeInput('setTemperature')"  
                                clear placeholder="请输入设温"></el-input>&nbsp;&nbsp;°C
                        </el-form-item>
                    </template>
                    
                    <el-form-item label="锁定" prop="lock">
                        <el-select v-model="form.lock" clearable placeholder="请选择">
                            <el-option
                                v-for="(v, i) in configData.lock"
                                :key="i"
                                :label="v.label"
                                :value="v.value"
                                :disabled="v.disable">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                    <el-form-item label="来电启动" prop="callstartstate">
                        <el-select v-model="form.callstartstate" clearable placeholder="请选择">
                           <el-option
                                v-for="(v, i) in configData.DDGK"
                                :key="i"
                                :label="v.label"
                                :value="v.value"
                                :disabled="v.disable">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <!-- <el-form-item v-if="controlType === 3" label="温度下限" prop="upperlimit">
                        <el-input-number v-model="form.upperlimit" controls-position="right" :step="1" :min="1" :max="50"></el-input-number>&nbsp;&nbsp;°C
                    </el-form-item>
                    <el-form-item v-if="controlType === 3" label="温度上限" prop="lowerlimit">
                        <el-input-number v-model="form.lowerlimit" controls-position="right" :step="1" :min="1" :max="50"></el-input-number>&nbsp;&nbsp;°C
                    </el-form-item> -->
                    <el-form-item label="通风模式" prop="ventilationmodeenables">
                        <el-select v-model="form.ventilationmodeenables" clearable placeholder="请选择">
                            <el-option
                                v-for="(v, i) in configData.windMode"
                                :key="i"
                                :label="v.label"
                                :value="v.value"
                                :disabled="v.disable">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <template v-if="controlType === 1">
                        <el-form-item label="风速" prop="windSpeed">
                            <el-select v-model="form.windSpeed" clearable placeholder="请选择">
                                <el-option
                                    v-for="(v, i) in configData.windSpeed"
                                    :key="i"
                                    :label="v.label"
                                    :value="v.value"
                                    :disabled="v.disable">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </template>
                    <template v-if="controlType === 2">
                        <el-form-item label="制冷温度" prop="cryogenictempertur">
                            <el-input v-model="form.cryogenictempertur"
                                @blur="handleChangeInput('cryogenictempertur')" 
                                clear placeholder="请输入制冷温度"></el-input>&nbsp;&nbsp;°C
                        </el-form-item>
                    </template>
                </el-col>
            </el-row>
        </el-form>
    </div>
    <template v-if="controlType === 3">
        <div class="container-title">控制组别</div>
        <div style="margin-left:150px;">
            <el-transfer
                :titles="['组别', '控制组别']"
                filterable
                :filter-method="filterMethod"
                filter-placeholder="请输入关键字"
                v-model="groupValue"
                :data="groupData">
            </el-transfer>
        </div>
    </template>
    <template v-if="controlType === 4">
        <div class="container-title">控制集控器</div>
        <div style="margin-left:150px;">
            <el-transfer
                :titles="['集控器', '控制集控器']"
                filterable
                :filter-method="filterMethod"
                filter-placeholder="请输入关键字"
                v-model="getawayValue"
                :data="getawayData">
            </el-transfer>
        </div>
    </template>
    <template v-if="controlType === 5">
        <div class="container-title">按楼宇结构控制</div>
        <div style="margin-left:150px;">
            <div style="width:400px;">
                <cmp-build-select 
                :buildRoom="buildRoom"
                changeOnSelect
                @listenBuildResult="listenBuildResult"></cmp-build-select>
            </div>  
        </div>
    </template>
    <div style="margin-left:150px;margin-top:20px;margin-bottom:50px">
        <el-button type="primary" style="width:200px;" :disabled="!checkPermission('device_control')" @click="onSubmit">确认执行</el-button>
    </div>
</div>
</template>

<script>
import { CLUSTERMANA } from '@/api/configData.js'
import Service from '@/api/Service'
import checkPermission from '@/utils/permission'
import {$Alert} from '@/utils/utils'
import CmpBuildSelect from '@/components/CmpBuildSelect/CmpBuildSelect'

export default {
    name: "clustermana",
    inject: ["reload"],
    data() {
        return {
            controlType: 1, //    控制方式
            //  控制参数设置
            form: {
                status: '',             //  状态
                module: '',            //  模式
                heatingtemperture: '',         //  制热温度
                cryogenictempertur: '',        //  制冷温度
                windSpeed: '',          //  风速
                setTemperature: '',     //  设温
                lock: '',           //  锁定

                callstartstate: '',             // 来电启动   
                upperlimit: '',    //  温度下限
                lowerlimit: '',  //  温度上限
                ventilationmodeenables: '',   //  通风模式
            }, 
            // 参数设置校验
            rules: {

            },
            
            configData: CLUSTERMANA,
            // 组别穿梭框
            groupData: [],
            groupValue: [],
            filterMethod(query, item) {
                return item.label.indexOf(query) > -1;
            },
            // 集控器穿梭框
            getawayData: [],
            getawayValue: [],
 
            // 选择房间组件
            buildRoom: {},
            houseOID: "",
        };
    },
    created() {
        this.getGroup();
    },
    components: {
        CmpBuildSelect,
    },
    methods: {
        checkPermission,
        //   选择控制方式
        handleChange(val) {
            
            if(val === 3) {
                this.getGroup();
                return;
            }
            if(val === 4) {
                this.getGateway();
                return;
            }
        },
        // 温度输入框
        handleChangeInput(key, val) {
            // let value = this.form[key];

            // if(isNaN(value) || value<10 || value>50) {
            //     this.$message({
            //         type: "warning",
            //         message: "温度可设置范围10-50;"
            //     })
            //     this.form[key] = "";
            // }
        },
        // 获取组别
        async getGroup() {
            if(this.groupData.length > 0) return;
            let data = await Service.getMeterGroupList();
            if(data) {
                data = data === 'success' ? [] : data;
                let arr = [];
                data.map(v=>{
                    arr.push({
                        key: v.OID,
                        label: v.GroupName
                    })
                })
                this.groupData = arr;
            }
        },
        // 获取集控器
        async getGateway() {
            if(this.getawayData.length > 0) return;
            let data = await Service.getCollector();
            if(data){
                data = data === 'success' ? [] : data;
                
                let arr = [];
                data.map(v=>{
                    arr.push({
                        key: v.oid,
                        label: v.dev_name
                    })
                })
                this.getawayData = arr;
            }
        },
        //   确认执行
        onSubmit() {
			let value = this.form.setTemperature;
            if(isNaN(value) || value<10 || value>50) {
                this.$message({
                    type: "warning",
                    message: "温度可设置范围10-50;"
                })
            }else{
			$Alert(`是否确认执行 `).then((bool)=>{
				if(bool){
            if(!checkPermission('device_control')) {
                this.$notify({
                    title: '警告',
                    message: '暂无操作权限',
                    type: 'warning'
                });
                return
            }
			
            if(this.controlType === 1 || this.controlType === 2) {
                // 控制风盘风柜
                this.ControlByTyp();
            }
            if(this.controlType === 3) {
                if(this.groupValue.length<=0) {
                    this.$notify({
                        title: '警告',
                        message: '请选择要控制的分组！',
                        type: 'warning'
                    });
                    return
                }
                // 控制分组
                this.ControlByGroup();
            }
			
            if(this.controlType === 4) {
                if(this.getawayValue.length<=0) {
                    this.$notify({
                        title: '警告',
                        message: '请选择要控制的集控器！',
                        type: 'warning'
                    });
                    return
                }
                // 控制分组
                this.ControlByCollectorID();
            }
			
            if(this.controlType === 5) {
                if(this.houseOID == "") {
                    this.$notify({
                        title: '警告',
                        message: '请选择要控制的楼宇！',
                        type: 'warning'
                    });
                    return
                }
                // 控制楼宇
                this.ControlByCollectorMidlist();
            }
			}
			});
			}
        },
        // 风盘风柜控制
        async ControlByTyp() {
            let form = Object.assign({},this.form);
            form.devtype = this.controlType;
            let data = await Service.controlByTye(form)
            if(data) {
                this.$message({
                    message: '操作成功',
                    type: 'success'
                });
                this.reload();
            }
        },
        // 分组控制
        async ControlByGroup() {
            let arr = this.groupValue.map(v=>{
                return {oid:v}
            })
            let form = Object.assign({},this.form);
           
            let params = Object.assign({}, form, {goupidlist: JSON.stringify(arr)})
            let data = await Service.controlByGroup(params)
            
            if(data) {
                this.$message({
                    message: '操作成功',
                    type: 'success'
                });
                this.reload();
            }
        },
        // 集控器控制
        async ControlByCollectorID() {
            let arr = this.getawayValue.map(v=>{
                return {oid:v}
            })
            let form = Object.assign({},this.form);

            let params = Object.assign({}, form, {collectorlist: JSON.stringify(arr)})
            let data = await Service.ControlByCollectorID(params)
            
            if(data) {
                this.$message({
                    message: '操作成功',
                    type: 'success'
                });
                this.reload();
            }
        },
        // 按楼宇结构控制
        async ControlByCollectorMidlist() {
            let arr = [{oid: this.houseOID + ""}];
            let form = Object.assign({},this.form);
            
            let params = Object.assign({}, form, {midlist: JSON.stringify(arr)})
            let data = await Service.controlByMidlist(params)
            
            if(data) {
                this.$message({
                    message: '操作成功',
                    type: 'success'
                });
                this.reload();
            }
        },
        // 最后一级房间确认信息
        listenBuildResult(data) {
            this.houseOID = data.oid;
        },
    }
};
</script>
<style lang='css' scoped>
</style>